import {z} from 'zod';
import {ExtendableError} from '@bluedrop-learning-networks/frontend-utils/errors';

/**
 * @description Must be consistent with other applications at the bluedrop platform!!!
 */
export const AUTH_TOKEN_KEY = 'bln:auth:user-token';

const schema = z.object({
	accountId: z.number().positive().finite(),
	expiration: z.string().datetime(),
	grantType: z.string(),
	sessionToken: z.string().startsWith('BLN'),
	userId: z.number().positive().finite(),
});

export class BlnAuthTokenError extends ExtendableError {}

export type TokenObject = z.infer<typeof schema>;

export function getBlnAuthTokenObject(localStorageItemKey?: string): TokenObject | null | never {
	try {
		// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
		const value = localStorage.getItem(localStorageItemKey || AUTH_TOKEN_KEY);

		if (!value) {
			return null;
		}

		const data = JSON.parse(value) as unknown;
		return schema.parse(data);
	} catch (cause) {
		throw new BlnAuthTokenError('BLN session token parsing has failed.', {cause});
	}
}

export default function getBlnAuthToken(localStorageItemKey?: string) {
	return getBlnAuthTokenObject(localStorageItemKey)?.sessionToken ?? null;
}
